import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useRef, useState } from 'react';
import Warning from '@hellodarwin/icons/dist/icons/Warning';
import { useTranslations } from '../../../features/providers/translations-provider';
import ModalController from '../../../features/providers/modal-provider/modal-confirm-controller';
import Button from '../button';
import Div from '../div';
import Typography from '../typography';
import { ModalContainer, ModalContent, ModalWrapper } from './styles';
import useModalOpenFunctions from './use-modal-open-functions';
export const ModalConfirmComponent = ({ onOk, onCancel, onClose, title, content, okText, cancelText, cancelButtonProps, okButtonProps, width, }) => {
    const { t } = useTranslations();
    const theme = useTheme();
    const [isConfirming, setIsConfirming] = useState(false);
    const isConfirmingRef = useRef(false);
    const { onCancel: onFinish, fadeOut, isOpen, } = useModalOpenFunctions({
        handleCancel: () => {
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            onClose();
        },
        open: true,
    });
    const handleConfirm = async () => {
        if (isConfirmingRef.current)
            return;
        isConfirmingRef.current = true;
        setIsConfirming(true);
        try {
            await onOk();
            onClose();
        }
        catch (err) {
            isConfirmingRef.current = false;
            setIsConfirming(false);
            throw err;
        }
    };
    if (!isOpen && !fadeOut)
        return null;
    return (_jsx(ModalWrapper, { onClick: onFinish, children: _jsx(ModalContainer, { "$size": "small", children: _jsx(ModalContent, { onClick: (e) => e.stopPropagation(), style: { width, minHeight: 'auto' }, children: _jsxs(Div, { flex: "column", gap: 24, children: [_jsxs(Div, { flex: "column", gap: 8, align: "center", children: [_jsx(Warning, { size: 48 }), _jsx(Typography, { elementTheme: "subtitle1", color: theme.colors.primary, textAlign: "center", children: title }), _jsx(Typography, { elementTheme: "body1", color: theme.colors.primary, textAlign: "center", children: content })] }), _jsxs(Div, { flex: "row", align: "center", justify: "center", gap: 8, children: [_jsx(Button, Object.assign({ defaultStyle: theme.colors.white_1 }, cancelButtonProps, { size: "small", disabled: isConfirming || (cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.disabled), onClick: onFinish, children: cancelText !== null && cancelText !== void 0 ? cancelText : t('button|cancel') })), _jsx(Button, Object.assign({ defaultStyle: theme.colors.purple_1 }, okButtonProps, { size: "small", loading: isConfirming || (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.loading), onClick: handleConfirm, children: okText !== null && okText !== void 0 ? okText : t('button|confirm') }))] })] }) }) }) }));
};
export const ModalConfirm = (props) => ModalController.getInstance().confirm(props);
export default ModalConfirm;
